<form [formGroup]="form" (ngSubmit)="saveChanges()">

  <div class="modal-header">
    <h4 class="modal-title">მენიუს რედაქტირება</h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body">

    <!-- მენიუს დასახელება -->
    <div class="form-floating mb-3">
      <input
        formControlName="title"
        type="text"
        id="title"
        class="form-control"
        placeholder="მენიუს დასახელება"
      />
      <label for="title">მენიუს დასახელება</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
        <div *ngIf="form.get('title')?.errors?.['required']">ველი სავალდებულოა</div>
        <div *ngIf="form.get('title')?.errors?.['minlength']">მინიმუმ 2 სიმბოლო</div>
      </div>
      <div class="text-danger small" *ngIf="apiErrors?.title">{{ apiErrors.title }}</div>
    </div>

    <!-- სტატუსი -->
    <div class="form-floating mb-3">
      <select formControlName="status" id="status" class="form-select">
        <option value="active">აქტიური</option>
        <option value="inactive">არააქტიური</option>
      </select>
      <label for="status">სტატუსი</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('status')?.invalid && form.get('status')?.touched">
        სტატუსი სავალდებულოა
      </div>
      <div class="text-danger small" *ngIf="apiErrors?.status">{{ apiErrors.status }}</div>
    </div>

    <!-- შობილი -->
    <div class="form-floating mb-3">
      <select formControlName="parent" id="parent" class="form-select">
        <option value="">არ გამოიყენოს</option>
        <option value="main">მთავარი</option>
        <option value="submenu">ქვემენიუ</option>
      </select>
      <label for="parent">შობილი</label>
    </div>


    <div class="mb-3">
      <app-parent-menu-select [selectedMenuId]="menuItem.up_id" (selected)="onSelectParent($event)"></app-parent-menu-select>
    </div>



    <!-- არ გამოიყენოს ქვემენიუები -->
    <div class="form-check mb-3">
      <input type="checkbox" class="form-check-input" id="disableSub" formControlName="disableSub" />
      <label class="form-check-label" for="disableSub">არ გამოიყენოს ქვემენიუები</label>
    </div>

    <!-- გვერის ტიპი -->
    <div class="form-floating mb-3">
      <select formControlName="pageType" id="pageType" class="form-select">
        <option value="static">Static</option>
        <option value="dynamic">Dynamic</option>
      </select>
      <label for="pageType">გვერის ტიპი</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('pageType')?.invalid && form.get('pageType')?.touched">
        გვერის ტიპი სავალდებულოა
      </div>
    </div>

    <!-- მენიუს პოზიცია -->
    <div class="form-floating mb-3">
      <select formControlName="position" id="position" class="form-select">
        <option value="main">Main</option>
        <option value="footer">Footer</option>
      </select>
      <label for="position">მენიუს პოზიცია</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('position')?.invalid && form.get('position')?.touched">
        მენიუს პოზიცია სავალდებულოა
      </div>
    </div>

    <!-- ბმულის დასახელება -->
    <div class="form-floating mb-3">
      <input formControlName="slug" id="slug" type="text" class="form-control" placeholder="Slug" />
      <label for="slug">ბმულის დასახელება</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('slug')?.invalid && form.get('slug')?.touched">
        ბმულის სახელი სავალდებულოა
      </div>
      <div class="text-danger small" *ngIf="apiErrors?.slug">{{ apiErrors.slug }}</div>
    </div>

    <!-- URL -->
    <div class="form-floating mb-3">
      <input formControlName="url" id="url" type="text" class="form-control" placeholder="URL" />
      <label for="url">გადამისამართება</label>

      <div class="invalid-feedback d-block"
           *ngIf="form.get('url')?.invalid && form.get('url')?.touched">
        URL სავალდებულოა
      </div>
      <div class="text-danger small" *ngIf="apiErrors?.url">{{ apiErrors.url }}</div>
    </div>

    <!-- ფანჯარა -->
    <div class="form-floating mb-3">
      <select formControlName="target" id="target" class="form-select">
        <option value="_self">ახალი</option>
        <option value="_blank">ახალ ფანჯარაში</option>
      </select>
      <label for="target">ფანჯარა</label>
    </div>

    <!-- გამოჩენა -->
    <div class="form-check mb-3">
      <input id="visible" class="form-check-input" type="checkbox" formControlName="visible" />
      <label class="form-check-label" for="visible">გამოჩენა</label>
    </div>

    <!-- მთავარი მენიუ -->
    <div class="form-check mb-3">
      <input id="mainMenu" class="form-check-input" type="checkbox" formControlName="mainMenu" />
      <label class="form-check-label" for="mainMenu">მთავარი მენიუ</label>
    </div>

    <!-- ფონი -->
    <div class="mb-3">
      <label class="form-label">ფონი:</label>
      <input type="file" class="form-control" (change)="onBackgroundSelect($event)" />
    </div>

    <!-- Icon -->
    <div class="mb-3">
      <label class="form-label">Icon:</label>
      <input type="file" class="form-control" (change)="onIconSelect($event)" />
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">დახურვა</button>

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid || load">
      <span *ngIf="load" class="spinner-border spinner-border-sm"></span>
      შენახვა
    </button>
  </div>
</form>